import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Modal, Form, Row, Col, Input, Select, Button, Tooltip, Tabs, InputNumber, Radio, DatePicker, Dropdown, Divider, Switch, Menu, Spin, Space, Drawer, TimePicker, Tag, message, Checkbox} from 'antd'
import { QuestionCircleFilled, MinusCircleOutlined, ExclamationCircleFilled, ExclamationCircleOutlined, PlusOutlined } from '@ant-design/icons'
import {withTranslation} from 'react-i18next'
import FormImport from './FormImport'
import PhoneList from './PhoneList'
import ResourcePoolList from '../../marketingResourcePool/components/ResourcePoolList'
import alertMessage from '../../../utils/alertMessage'
import history from '../../../routes/history'
import moment from 'moment'
const storage = window.localStorage
const { TabPane } = Tabs;
const {TextArea} = Input
const { RangePicker } = DatePicker;
@inject('intelligentOutboundCallStore', 'marketingSmsManagementStore', 'marketingSmsTemplateStore', 'marketingShortLinkStore', 'accountStore')
@observer
class FormModal extends Component {
  state = {
    regularlyTime: null,
    modalVisible: false,
    importModalVisible: false,
    shortLinkModalVisible: false,
    detailsModalVisible: false,
    content: '',
    textAreaStart: 0,
    sum: 0,
    sourceType: '',
    isValid: '',
    groupVal: '',
    editVarVisible: false,
    phoneContent: '',
    personalPhoneVisible: false,
    record: null,
    isTable: false,
    isFile: false,
    isResourcePool: false,
    selectedTime: null,
    isDatePicker: 0,
    testSendModalVisible: false,
    enableRecalling: false,  // 重拨设置开关状态
    enableNoAnswer: true,  // 无应答设置开关状态
    smsEnabled: false,  // 发送短信开关状态
    smsSendLimitType: false,  // 允许重复发送短信状态
    testTableData: [], // 测试表格数据
    testTableColumns: [], // 测试表格列配置
    timeRanges: [
      { id: 1, startTime: moment('00:00', 'HH:mm'), endTime: moment('00:05', 'HH:mm') }
    ],
    maxConcurrency: 1,
    signNum: 0,   //签名
    characterNum: 0,  //模板内容
    suffixNum: 0,  //后缀
    strNum: 0,  //字符数
    smsNum: 0,  //短信数
    signValue: '', // 签名内容
    templateValue: '', // 模板内容
   }

  formRef = React.createRef()
  testFormRef = React.createRef()

  componentDidMount() {
    const {intelligentOutboundCallStore, marketingSmsManagementStore, accountStore, location, t} = this.props
    const {accountInfos} = accountStore
    const infos = JSON.parse(storage.getItem('accountInfos'))
    
    // 并行加载所有接口，等待完成后再初始化表单
    Promise.all([
      marketingSmsManagementStore.onGetGroup({
        isPowerUser : accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser,
      }),
      intelligentOutboundCallStore.onGetCallerList(),
      intelligentOutboundCallStore.onGetModelList(),
      intelligentOutboundCallStore.onExpoAction(),
      intelligentOutboundCallStore.onGetStatus('TimeSlots'),
    ]).then(() => {
      // 所有接口加载完成后，初始化表单
      this.formRef.current.setFieldsValue({
        'suffixContent': t(`marketingManagement.replyWithR`),
        'taskType': 0,
        'time_slots': [[]], // 默认显示一条执行时间段
        'marketGroupId': location?.state?.marketGroupId || undefined,
        'smsOn': ['1'],
        'enableRecalling': false,
        'enableNoAnswer': true,
        'smsEnabled': false,
        'smsSendLimitType': false,
      })
      if(location?.state?.marketGroupId) {
        this.onChangeGroup(location?.state?.marketGroupId, true)
      }
    })
    
    if (location?.state) {
      history.replace({
        state: {} // 清空路由状态
      });
    }
  }
  // 点击按钮 提交发送
  handleOkConfirm = () => {
    const {t, intelligentOutboundCallStore, marketingSmsManagementStore} = this.props
    const that = this
    const { handPhoneNum, filePhoneNum, resourcePhoneNum, modelList} = intelligentOutboundCallStore
    const { generateID} = marketingSmsManagementStore 
    this.formRef.current.validateFields().then(fieldsValue => {
      if ((handPhoneNum + filePhoneNum + resourcePhoneNum) > 0) {
        Modal.confirm({
          title: '是否确定发送',
          icon: <ExclamationCircleOutlined/>,
          centered: true,
          // content: <div>
          //   {t(`marketingManagement.total4`)}
          //   <span style={{color: '#ff5200'}}> {this.state.phoneContent?.length} </span>
          //   {t(`marketingManagement.total2`)}
          //   <span style={{color: 'red'}}>{(this.state.phoneContent?.length) > 70 ? Math.ceil((this.state.phoneContent?.length) / 67) : 1}</span>
          //   {t(`marketingManagement.total3`)}
          // </div>,
          onOk() {
            let params = {
              id: generateID,
              taskName: fieldsValue?.taskName,
              marketGroupId: fieldsValue?.marketGroupId,
              expoResume: fieldsValue?.expoResume,
              sceneModelId: fieldsValue?.sceneModelId,
              sceneModelDataId: modelList?.find(a=>a?.id === fieldsValue?.sceneModelId)?.dataId || undefined,
              callerId: fieldsValue?.callerId,
              maxConcurrency: fieldsValue?.maxConcurrency || 1,
              taskType: fieldsValue?.taskType,
              scheduleConfig: fieldsValue?.taskType === 1 ? {
                valid_date: {
                  start: fieldsValue?.valid_date?.[0]?.format('YYYY-MM-DD'),
                  end: fieldsValue?.valid_date?.[1]?.format('YYYY-MM-DD'),
                },
                week_days: fieldsValue?.week_days,
                time_slots: fieldsValue?.time_slots?.map(slot => ({
                  start: slot[0]?.format('HH:mm'),
                  end: slot[1]?.format('HH:mm'),
                })),
              } : null,
              enableRecalling: that.state?.enableRecalling ? 1 : 0,
              enableNoAnswer: fieldsValue?.enableNoAnswer ? 1 : 0,
              recallingNumber: fieldsValue?.recallingNumber,
              recallingInterval: fieldsValue?.recallingInterval,
              smsEnabled: that.state?.smsEnabled ? 1 : 0,
              // smsOn: fieldsValue?.smsOn,
              smsSendLimitType: fieldsValue?.smsSendLimitType ? 1 : 0,
              smsOnConnected: fieldsValue?.smsOn?.includes('1') ? 1 : 0,
              smsOnUnanswered: fieldsValue?.smsOn?.includes('2') ? 1 : 0,
              smsSignId: fieldsValue?.smsSignId,
              smsTemplateId: fieldsValue?.smsTemplateId,
              smsPreview: fieldsValue?.smsPreview,
            }
            intelligentOutboundCallStore.onAddAction(params).then(res=> {
              if (res?.data?.code === 0) {
                that.formHandleCancel('',true)
              }
            })
          },
          onCancel() {},
        })
      } else {
        alertMessage.error('请输入手机号码!')
      }
    }).catch(() => {})
  }
  // 修改 营销分组
  onChangeGroup = (value, isFormPool) => {
    const { accountStore, intelligentOutboundCallStore, marketingSmsManagementStore, marketingSmsTemplateStore, location } = this.props
    const { handPhoneNum, filePhoneNum, resourcePhoneNum } = intelligentOutboundCallStore
    const { generateID, groupList } = marketingSmsManagementStore
    const {accountInfos} = accountStore
    const infos = JSON.parse(storage.getItem('accountInfos'))
    let maxConcurrency = groupList?.find(a=>a?.id ===value)?.aiMaxConcurrency || 1
    this.formRef.current.setFieldsValue({
      'expoResume': undefined,
      'sceneModelId': undefined,
      'callerId': undefined,
      'maxConcurrency': maxConcurrency,
      'valid_date': undefined,
      'week_days': undefined,
      'time_slots': [],
      'taskType': 0,
      'enableRecalling': false,
      'enableNoAnswer': true,
      'recallingNumber': 1,
      'recallingInterval': 24,
      'smsEnabled': false,
      'smsOn': ['1'],
      'smsSendLimitType': false,
      'smsOnConnected': 0,
      'smsOnUnanswered': 0,
      'smsSignId': undefined,
      'smsTemplateId': undefined,
      'smsPreview': undefined,
    })
    this.setState({
        groupVal: value,
        phoneContent: '',
        content: '',
        maxConcurrency: maxConcurrency,
        taskType: 0,
        characterNum: 0,
        strNum: 0, 
        smsNum: 0,
    })
    /* 清空号码 */
    if (!isFormPool && (handPhoneNum + filePhoneNum + resourcePhoneNum) > 0) {
      intelligentOutboundCallStore.onClearPhoneAction(generateID).then(res=> {
        if (res.data?.code === 0) {
          intelligentOutboundCallStore.onStatisticsAction(generateID)
        }
      })
    }
    //获取资源池的 下拉列表
    intelligentOutboundCallStore.onGetResourcePool({
      configTypeList: ['4'],
      marketingGroupId: [value],
    })
    // 加载短信签名列表
    marketingSmsManagementStore.onGetSign({
      marketGroupId: value,
      templateType: '1',
      isPowerUser : accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser,
    })
    // 加载短信模板列表
    marketingSmsTemplateStore.onSearchAction({
      templateType: '1',
      status: '1',
      isPowerUser : accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser,
      marketGroupId: value,
      page: 1, 
      size: 999999
    })
  }
  // 点击按钮 文件导入
  handleImportFile = (e,type, isTable) => {
    this.setState({
      importModalVisible: true,
      sourceType: type,
      isTable: isTable
    })
  }
  handleCancelImportFile = () => {
    this.setState({
      importModalVisible: false,
      sourceType: '',
      isFile: false
    })
  }
  // 点击按钮 资源池导入
  handleImportResourcePool = (e, value, isTable) => {
    this.setState({
      detailsModalVisible: true,
      sourceType: '3',
      record: value,
      isTable: isTable
    })
  }
  handleCancelResourcePool =()=> {
    this.setState({
      detailsModalVisible: false,
      sourceType: '',
      record: null,
      isResourcePool: false
    })
  }
  // 点击按钮 详情
  importDetails = (e,type, isValid) => {
    this.setState({
      phoneVisible: true,
      sourceType: type,
      isValid: isValid,
    })
  }
  handleCancelPhoneList =()=> {
    this.setState({
      phoneVisible: false,
      sourceType: '',
      isValid: '',
    })
  }
  // phoneTextArea 发送手机号码文本框 修改
  onChangeHandPhone =(text)=> {
    const value = text.target.value
    //较验手机号的正则表达式
    const regPhone = /^((1[3,5,7,8,9][0-9])|(14[5,7])|(17[0,6,7,8])|(19[7]))\d{8}$/
    if(value.length===11) {
      const result = regPhone.test(value)
      if(result) {
        this.addPhone([value])
      } else {
        alertMessage.error('号码格式不正确!')
      }
    } else if(value.length > 11 &&(value.includes(',') || value.includes('，'))) {
      const str = value.replace(/，/g, ",")
      const arr = str.split(',')
      const newArr = arr.filter(a=>regPhone.test(a))
      if(newArr.length>0) {
        this.addPhone(newArr)
      }
    // } else {
    //   alertMessage.error('号码格式不正确!')
    }
  }
  // 添加手机号码
  addPhone = (value) => {
    const { intelligentOutboundCallStore, marketingSmsManagementStore } = this.props
    const { generateID } = marketingSmsManagementStore
    intelligentOutboundCallStore.onAddPhoneAction({
      "dataSource": "",
      "phoneList": value,
      "taskId": generateID,
      "taskGroupId": this.state.groupVal,
    }).then(res=> {
      if (res?.data?.code === 0) {
        intelligentOutboundCallStore.onStatisticsAction(generateID)
        this.formRef.current.setFieldsValue({
          'phoneTextArea': undefined,
        })
      }
    })
  }
  // 关闭 新建短信 窗口
  formHandleCancel=(e, status)=> {
    const { intelligentOutboundCallStore, marketingSmsManagementStore, handleCancel } = this.props
    const { handPhoneNum, filePhoneNum, resourcePhoneNum } = intelligentOutboundCallStore
    const { generateID } = marketingSmsManagementStore 
    if(!status && (handPhoneNum + filePhoneNum + resourcePhoneNum) > 0) {
      intelligentOutboundCallStore.onClearPhoneAction(generateID)
    }
    handleCancel()
    this.setState({
      regularlyTime: null,
      modalVisible: false,
      importModalVisible: false,
      shortLinkModalVisible: false,
      detailsModalVisible: false,
      content: '',
      textAreaStart: 0,
      sum: 0,
      sourceType: '',
      groupVal: '',
      editVarVisible: false,
      phoneContent: '',
      personalPhoneVisible: false,
      record: null,
      isTable: false,
      isFile: false,
      isResourcePool: false,
      selectedTime: null,
      isDatePicker: 0,
      testSendModalVisible: false,
      testTableData: [],
      testTableColumns: [],
      characterNum: 0,
      strNum: 0,
      smsNum: 0,
    })
  }
  createPool = () => {
    const {accountStore} = this.props
    history.push(`/resourcePool`)
    accountStore.setSeletedItem('resourcePool')
    accountStore.onMenuClick(['resourcePool'])
  }

  // 提取内容中的变量
  extractVariables = (content) => {
    if (!content) return []
    const variables = content.match(/\{%([^%]+)%\}/g)
    if (!variables) return []
    return variables?.map(variable => variable.replace(/\{%|\%\}/g, ''))
  }

  // 获取表格列定义（Form.List fields, add, remove）
  getTestTableColumns = (fields, add, remove) => {
    const variables = this.extractVariables(this.state.content)
    const columns = [
      {
        title: '手机号码',
        dataIndex: '手机号码',
        key: 'phone',
        width: 150,
        render: (text, record, idx) => (
          <Form.Item name={[record.name, '手机号码']} style={{ margin: 0 }}>
            <Input placeholder="请输入手机号" />
          </Form.Item>
        )
      },
      ...variables?.map(variable => ({
        title: variable,
        dataIndex: variable,
        key: variable,
        width: 150,
        render: (text, record) => (
          <Form.Item name={[record.name, variable]} style={{ margin: 0 }}>
            <Input placeholder={`请输入${variable}`} />
          </Form.Item>
        )
      })),
      {
        title: '操作',
        key: 'action',
        width: 80,
        render: (text, record, idx) => (
          <span>
            <Button size="small" onClick={() => fields.length < 10 && add()} disabled={fields.length >= 10} style={{ marginRight: 4 }}>+</Button>
            <Button size="small" onClick={() => remove(record.name)} disabled={fields.length === 1}>-</Button>
          </span>
        )
      }
    ]
    return columns
  }

  // 打开测试发送弹窗时初始化一行
  handleShowTestSend = () => {
    this.formRef.current.validateFields().then(fieldsValue => {
      this.setState({
        testSendModalVisible: true
      }, () => {
        // 初始化一行
        this.testFormRef.current && this.testFormRef.current.setFieldsValue({ testData: [{}] })
      })
    }).catch(() => { })
  }

  // 测试发送
  handleTestSend = () => {
    const { intelligentOutboundCallStore } = this.props
    const { modelList } = intelligentOutboundCallStore
    this.formRef.current.validateFields().then(fieldsValue => {
      const { intelligentOutboundCallStore, onSearch } = this.props

      // 通用参数
      const paramsBase = {
        taskName: '测试 - ' + moment().format('YYYY-MM-DD HH:mm:ss'),
        marketGroupId: fieldsValue?.marketGroupId,
        expoResume: fieldsValue?.expoResume,
        sceneModelId: fieldsValue?.sceneModelId,
        sceneModelDataId: modelList?.find(a=>a?.id === fieldsValue?.sceneModelId)?.dataId || undefined,
        callerId: fieldsValue?.callerId,
        maxConcurrency: fieldsValue?.maxConcurrency,
        enableRecalling: 0,
        enableNoAnswer: 0,
        recallingNumber: 0,
        recallingInterval: 0,
        smsEnabled: fieldsValue?.smsEnabled ? 1 : 0,
        // smsOn: fieldsValue?.smsOn,
        smsSendLimitType: fieldsValue?.smsSendLimitType ? 1 : 0,
        smsOnConnected: fieldsValue?.smsOn?.includes('1') ? 1 : 0,
        smsOnUnanswered: fieldsValue?.smsOn?.includes('2') ? 1 : 0,
        smsSignId: fieldsValue?.smsSignId,
        smsTemplateId: fieldsValue?.smsTemplateId,
        smsPreview: fieldsValue?.smsPreview,
      }

      let phoneList = []

      // 普通短信校验
      const receiver = this.testFormRef.current.getFieldValue('testPhoneArea')
      if (!receiver) {
        alertMessage.error("请输入测试手机号").then()
        return
      }
      const regPhone = /^((1[3,5,7,8,9][0-9])|(14[5,7])|(17[0,6,7,8])|(19[7]))\d{8}$/
      const arr = receiver.replace(/，/g, ',').split(',')
      const okArr = arr.filter(a => regPhone.test(a)) ?? []
      const failedArr = arr.filter(a => !regPhone.test(a)) ?? []
      if (failedArr.length > 0) {
        let error = "错误的手机号：" + failedArr.join(',') + " 请重新输入"
        alertMessage.error(error, 5).then()
        return
      }
      if (okArr.length > 10) {
        alertMessage.error("当前测试手机号只允许10个以内的手机号").then()
        return
      }
      phoneList = okArr
      

      const params = {
        ...paramsBase,
        phoneNumbers: phoneList
      }
      intelligentOutboundCallStore.onSendTestPhone(params).then(() => {
        this.setState({ testSendModalVisible: false })
        onSearch()
      })
    }).catch(() => {})
  }

  //关闭测试发送窗口
  handleCancelTestSend = () => {
    this.setState({ 
      testSendModalVisible: false,
      testTableData: [],
      testTableColumns: []
    })
  }
  // 修改 签名
  onChangeSign = (e,option) => {
    const signSun = (option?.children || '').length
    const strSum = parseInt(signSun)+parseInt(this.state.characterNum)+parseInt(this.state.suffixNum)
    this.setState({
      signNum: signSun,
      strNum: strSum,
      smsNum: strSum > 70 ? Math.ceil(strSum/67) : 1,
      signValue: option?.children,
    })
    this.formRef.current.setFieldsValue({
      smsPreview: option?.children + this.state.templateValue,
    })
  }
  // 修改 模板
  onChangeTemplate = (e) => {
    const { marketingSmsTemplateStore } = this.props
    const { jobList } = marketingSmsTemplateStore
    const templateSun = parseInt((jobList?.find(a=>a?.id === e)?.template || '').length)
    const suffixSum = parseInt((jobList?.find(a=>a?.id === e)?.templateSuffix || '').length)
    const strSum = parseInt(this.state.signNum)+templateSun+suffixSum
    this.setState({
      characterNum: templateSun,
      suffixNum: suffixSum,
      strNum: strSum,
      smsNum: strSum > 70 ? Math.ceil(strSum/67) : 1,
      templateValue: jobList?.find(a=>a?.id === e)?.template + jobList?.find(a=>a?.id === e)?.templateSuffix,
    })
    this.formRef.current.setFieldsValue({
      smsPreview: this.state.signValue + jobList?.find(a=>a?.id === e)?.template + jobList?.find(a=>a?.id === e)?.templateSuffix,
    })
  }

  render() {
    const { intelligentOutboundCallStore, marketingSmsManagementStore, marketingSmsTemplateStore, addModalVisible, title, t } = this.props
    const { 
      isFetchingPhone, validHandPhoneNum, invalidHandPhoneNum, 
      validFilePhoneNum, invalidFilePhoneNum, validResourcePhoneNum, invalidResourcePhoneNum, 
      resourcePoolList, expoList, customWorkday, isTestSendFetching, callerList, modelList, timeSlotsList
    } = intelligentOutboundCallStore
    const { groupList, signList } = marketingSmsManagementStore
    const { jobList } = marketingSmsTemplateStore
    const { maxConcurrency } = this.state
    const formItemProps = {
      labelCol: {
          span: 8,
      },
      wrapperCol: {
          span: 16,
      },
    }
    const formItemLayout = {
      labelCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 8,
        },
      },
      wrapperCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 16,
        },
      },
    };
    const formItemLayoutWithOutLabel = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };
    return (
      <>
        <Modal
          title={title === 'edit' ? t(`general.edit`) + t(`menu.intelligentCallManagement`) : t(`general.addData`) + t(`menu.intelligentCallManagement`)}
          closable={true}
          visible={addModalVisible}
          onCancel={e=>this.formHandleCancel(e,false)}
          maskClosable={false}
          destroyOnClose={true}
          width={'48%'}
          centered
          footer={[
            <Button key="Test" type="primary" onClick={this.handleShowTestSend} >{t(`general.testCall`)}</Button>,
            <Button key="Save" type="primary" onClick={this.handleOkConfirm} >{t(`general.submitTask`)}</Button>,
            <Button key="Cancel" onClick={e=>this.formHandleCancel(e,false)}>{t(`general.cancel`)}</Button>,
          ]}
        >
          <Spin spinning={isFetchingPhone}>
          <Row gutter={[10, 10]}>
            <Col span={24}>
              <Form ref={this.formRef} key="addMapping">
                <Row gutter={[10, 10]}>
                  <Col span={4}><div className='leftTit'>{t(`marketingManagement.taskTitle`)}</div></Col>
                  <Col span={20}>
                    <Form.Item name="taskName" rules={[{required: true, message: `${t(`general.pleaseEnter`)} ${t(`marketingManagement.taskTitle`)}`}]}>
                      <Input showCount maxLength={20} placeholder='本次发送任务标题' />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item name="marketGroupId" label={t(`marketingManagement.marketingGroup`)} {...formItemLayout}
                      rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`marketingManagement.marketingGroup`)}`}]}
                      >
                      <Select placeholder={t(`general.pleaseSelect`)} showSearch filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      } onChange={this.onChangeGroup}>
                        {groupList?.map(item => (<Select.Option key={item.id} value={item.id}>{item.groupName}</Select.Option>))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item name="expoResume" label={t(`marketingManagement.exhibitionSession`)}
                      rules={[{required: true, message: `仅用于统计`}]} {...formItemLayout}
                    >
                      <Select placeholder='仅用于统计' allowClear showSearch filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      } disabled={!this.state.groupVal}>
                        {expoList?.map(item => (<Select.Option key={item?.expoResume} value={item?.expoResume}>{item?.expoCityName ? `${item?.expoResume}-${item?.expoCityName}` : `${item?.expoResume}`}</Select.Option>))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item name="sceneModelId" label={t(`outboundCall.scenarioModel`)} {...formItemLayout}
                      rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`outboundCall.scenarioModel`)}`}]}
                      >
                      <Select placeholder={t(`general.pleaseSelect`)} showSearch filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      } disabled={!this.state.groupVal}>
                        {modelList?.map(item => (<Select.Option key={item.id} value={item.id}>{item.modelName}</Select.Option>))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item name="callerId" label={t(`outboundCall.callerNumber`)} {...formItemLayout}
                      rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`outboundCall.callerNumber`)}`}]}
                    >
                      <Select placeholder={t(`general.pleaseSelect`)} allowClear showSearch filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      } disabled={!this.state.groupVal}>
                        {callerList?.map(item => (<Select.Option key={item?.callerNumber} value={item?.callerNumber}>{item?.callerNumber}（{item?.callerName}）</Select.Option>))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item name="maxConcurrency" label={t(`outboundCall.maxConcurrentCalls`)} {...formItemLayout}
                      rules={[
                        {required: true, message: `${t(`general.pleaseSelect`)} ${t(`outboundCall.maxConcurrentCalls`)}`},
                        {
                          validator: (rule, value) => {
                            if (value && value > maxConcurrency) {
                              return Promise.reject(`${t(`outboundCall.maxConcurrentCallsTips`)} ${this.state.maxConcurrency}`);
                            }
                            return Promise.resolve();
                          }
                        }
                      ]}
                      >
                      <InputNumber placeholder={t(`general.pleaseEnter`)} disabled={!this.state.groupVal} style={{width: '100%'}} min={1}/>
                    </Form.Item>
                  </Col>
                  <Col span={12} className='outboundCallRadio'>
                    <Form.Item name="taskType" label={t(`outboundCall.taskType`)} {...formItemLayout}
                      rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`outboundCall.taskType`)}`}]}
                    >
                      <Radio.Group onChange={(e)=>{
                        this.setState({taskType: e.target.value})
                        this.formRef.current.setFieldsValue({
                          valid_date: null, 
                          week_days: undefined, 
                          time_slots: e.target.value === 1 ? [[]] : []
                        })
                      }}>
                        <Radio value={0}>
                          <Tooltip title={
                            <div>
                              <div>智能外呼允许时间范围：</div>
                              <div>{timeSlotsList?.[0]?.code}  {timeSlotsList?.[1]?.code}</div>
                            </div>
                          }>
                            <span>{t(`outboundCall.taskType1`)} <QuestionCircleFilled /></span>
                          </Tooltip>
                        </Radio>
                        <Radio value={1}>{t(`outboundCall.taskType2`)}</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                  {this.state.taskType === 1 && (<>
                    {/* <Row style={{ background: 'rgba(7, 58, 120, .03)', padding: '10px 10px 0'}}> */}
                      <Col span={24} style={{borderTop: '1px solid #e8e8e8'}} />
                      <Col span={12}>
                        <Form.Item name="valid_date" label={t(`outboundCall.executionDate`)} {...formItemLayout}
                          rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`outboundCall.executionDate`)}`}]}
                        >
                          <RangePicker style={{width: '100%'}} format="YYYY-MM-DD" placeholder={[t(`outboundCall.startTime`), t(`outboundCall.endTime`)]} allowClear/>
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item name="week_days" label={t(`outboundCall.customWorkday`)} {...formItemLayout}
                          rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`outboundCall.customWorkday`)}`}]}
                        >
                          <Select placeholder={t(`general.pleaseSelect`)} mode="multiple" allowClear showSearch filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                          }>
                            {customWorkday?.map(item => (<Select.Option key={item?.id} value={item?.id}>{item?.name}</Select.Option>))}
                          </Select>                        
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.List name="time_slots"
                          rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`outboundCall.executionTimeRange`)}`}]}
                        >
                          {(fields, { add, remove }, { errors }) => (
                            <>
                              {fields?.map((field, index) => (
                                <Form.Item
                                  {...(index === 0 ? formItemLayout : formItemLayoutWithOutLabel)}
                                  label={index === 0 ? t(`outboundCall.executionTimeRange`) : ''}
                                  required={true}
                                  key={field.key}
                                >
                                  <Form.Item
                                    {...field}
                                    rules={[
                                      {
                                        required: true,
                                        message: `${t(`general.pleaseSelect`)} ${t(`outboundCall.executionTimeRange`)}`,
                                      },
                                    ]}
                                    style={{ display: 'inline-block', width: '90%' }}
                                  >
                                    <TimePicker.RangePicker 
                                      format="HH:mm"
                                      style={{ width: '100%' }}
                                      disabledTime={(date, type) => {
                                        // 如果 timeSlotsList 为空，不禁用任何时间
                                        if (!timeSlotsList || timeSlotsList.length === 0) {
                                          return {}
                                        }
                                        
                                        // 解析所有可用时间段
                                        const availableRanges = timeSlotsList.map(slot => {
                                          const [start, end] = (slot?.code || '').split('-')
                                          const [startHour, startMinute] = start ? start.split(':').map(Number) : [0, 0]
                                          const [endHour, endMinute] = end ? end.split(':').map(Number) : [23, 59]
                                          return {
                                            startHour,
                                            startMinute,
                                            endHour,
                                            endMinute
                                          }
                                        })
                                        
                                        // 禁用小时：不在任何可用时间段内的小时
                                        const disabledHours = () => {
                                          const disabled = []
                                          for (let h = 0; h < 24; h++) {
                                            const isInAnyRange = availableRanges.some(range => {
                                              // 检查这个小时是否在任何时间段内
                                              const hourStart = range.startHour
                                              const hourEnd = range.endHour
                                              return h >= hourStart && h <= hourEnd
                                            })
                                            if (!isInAnyRange) {
                                              disabled.push(h)
                                            }
                                          }
                                          return disabled
                                        }
                                        
                                        // 禁用分钟：对于可用时间段内的小时，禁用时间段外的分钟
                                        const disabledMinutes = (hour) => {
                                          const disabled = []
                                          // 找到包含这个小时的时间段
                                          const range = availableRanges.find(r => hour >= r.startHour && hour <= r.endHour)
                                          if (!range) {
                                            // 如果这个小时不在任何时间段内，禁用所有分钟
                                            return Array.from({length: 60}, (_, i) => i)
                                          }
                                          
                                          // 如果是起始小时，禁用起始分钟之前的分钟
                                          if (hour === range.startHour) {
                                            for (let m = 0; m < range.startMinute; m++) {
                                              disabled.push(m)
                                            }
                                          }
                                          // 如果是结束小时，禁用结束分钟之后的分钟
                                          if (hour === range.endHour) {
                                            for (let m = range.endMinute + 1; m < 60; m++) {
                                              disabled.push(m)
                                            }
                                          }
                                          return disabled
                                        }
                                        
                                        return {
                                          disabledHours,
                                          disabledMinutes
                                        }
                                      }}
                                    />
                                  </Form.Item>
                                  {fields.length > 1 ? (
                                    <MinusCircleOutlined
                                      className="dynamic-delete-button"
                                      onClick={() => remove(field.name)}
                                      style={{ marginLeft: 10, marginTop: 10 }}
                                    />
                                  ) : null}
                                </Form.Item>
                              ))}
                              <Form.Item {...formItemLayoutWithOutLabel}>
                                <Button
                                  type="link"
                                  onClick={() => add()}
                                  icon={<PlusOutlined />}
                                  style={{margin: '-10px 0 0 -20px'}}
                                >
                                  {t(`outboundCall.addTimeRange`)}
                                </Button>
                                <Form.ErrorList errors={errors} />
                              </Form.Item>
                            </>
                          )}
                        </Form.List>
                      </Col>
                    {/* </Row> */}
                  </>)}
                  <Col span={24}><div className='leftTit'>{t(`marketingManagement.sendPhone`)}</div></Col>
                  <Col span={24} style={{marginBottom: 20}}>
                      <Row gutter={8}>
                        {this.state.groupVal ?
                        <Col span={24}>
                          <div className='interSum sms' style={{ background: 'rgba(7, 58, 120, .03)', padding: 10}}>
                            <Row gutter={50}>
                              <Col flex="180px" style={{alignItems: 'center', borderRight: '1px solid #dddddd'}}>
                                <span style={{color: 'rgb(115, 209, 61)', fontSize: 20}}>
                                  {this.state.groupVal && validHandPhoneNum + validFilePhoneNum +  validResourcePhoneNum > 0 ? <Button type='link' onClick={e=>this.importDetails(e, null, 1)} style={{padding: 0, color: 'rgb(115, 209, 61)', fontSize: 20}}>{validHandPhoneNum + validFilePhoneNum +  validResourcePhoneNum}</Button> : validHandPhoneNum + validFilePhoneNum +  validResourcePhoneNum}
                                </span><br />
                                <span style={{color: 'rgb(115, 209, 61)', fontWeight: 'bold'}}>{t(`marketingManagement.numberText7`)}</span>
                                <Tooltip title={t('marketingManagement.personalTemplateTips')}>
                                  <QuestionCircleFilled />
                                </Tooltip>
                              </Col>
                              <Col flex="auto">
                                <Row gutter={16}>
                                  <Col span={8}>
                                    <span style={{color: 'rgb(115, 209, 61)', fontSize: 20}}>{this.state.groupVal && validHandPhoneNum > 0 ? <Button type='link' onClick={e=>this.importDetails(e,'MANUAL', 1)} style={{padding: 0, color: 'rgb(115, 209, 61)', fontSize: 20}}>{validHandPhoneNum}</Button> : validHandPhoneNum}</span>
                                    <span style={{color: '#999999'}}> / </span>
                                    <span style={{color: 'rgb(255, 77, 79)'}}>{this.state.groupVal && invalidHandPhoneNum > 0 ? <Button type='link' onClick={e=>this.importDetails(e,'MANUAL', 0)} style={{padding: 0, color: 'rgb(255, 77, 79)'}}>{invalidHandPhoneNum}</Button> : invalidHandPhoneNum}</span><br />
                                    <span style={{color: '#666666'}}>{t(`marketingManagement.numberText1`)}</span>
                                  </Col>
                                  <Col span={8}>
                                    <span style={{color: 'rgb(115, 209, 61)', fontSize: 20}}>{this.state.groupVal && validFilePhoneNum > 0 ? <Button type='link' onClick={e=>this.importDetails(e,'FILE', 1)} style={{padding: 0, color: 'rgb(115, 209, 61)', fontSize: 20}}>{validFilePhoneNum}</Button> : validFilePhoneNum}</span>
                                    <span style={{color: '#999999'}}> / </span>
                                    <span style={{color: 'rgb(255, 77, 79)'}}>{this.state.groupVal && invalidFilePhoneNum > 0 ? <Button type='link' onClick={e=>this.importDetails(e,'FILE', 0)} style={{padding: 0, color: 'rgb(255, 77, 79)'}}>{invalidFilePhoneNum}</Button> : invalidFilePhoneNum}</span><br />
                                    <span style={{color: '#666666'}}>{t(`marketingManagement.numberText2`)}</span>
                                  </Col>
                                  <Col span={8}>
                                    <span style={{color: 'rgb(115, 209, 61)', fontSize: 20}}>{this.state.groupVal && validResourcePhoneNum > 0 ? <Button type='link' onClick={e=>this.importDetails(e,'POOL', 1)} style={{padding: 0, color: 'rgb(115, 209, 61)', fontSize: 20}}>{validResourcePhoneNum}</Button> : validResourcePhoneNum}</span>
                                    <span style={{color: '#999999'}}> / </span>
                                    <span style={{color: 'rgb(255, 77, 79)'}}>{this.state.groupVal && invalidResourcePhoneNum > 0 ? <Button type='link' onClick={e=>this.importDetails(e,'POOL', 0)} style={{padding: 0, color: 'rgb(255, 77, 79)'}}>{invalidResourcePhoneNum}</Button> : invalidResourcePhoneNum}</span><br />
                                    <span style={{color: '#666666'}}>{t(`marketingManagement.numberText3`)}</span>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          </div>
                        </Col> : null
                        }
                        <Col span={24} className='phoneTextArea'>
                          <Form.Item name='phoneTextArea' style={{marginBottom: 0}}>
                            <TextArea onPressEnter={this.onChangeHandPhone} disabled={!this.state.groupVal} rows={3} placeholder="请输入11位手机号" style={{width: '100%'}} />
                          </Form.Item>
                        </Col>
                        <Col span={24}>
                          <div className='f_red' style={{ float: 'left', paddingLeft: '10px', paddingTop: '10px' }}><ExclamationCircleFilled /> 请输入正确的手机号，多个手机号使用逗号分隔，按回车键确认正确的手机号</div>
                          <div className='shortLink' style={{textAlign: 'right'}}>
                            <Button disabled={!this.state.groupVal} type="primary" onClick={e=>this.handleImportFile(e, '2')} style={{marginRight: 10}}>{t(`marketingManagement.importFile`)}</Button>
                            <Dropdown overlay={resourcePoolList?.length > 0 ? (<Menu>
                              {resourcePoolList?.map((b,i)=><Menu.Item key={i}><a onClick={e=>this.handleImportResourcePool(e, b)} href='#'>{b?.resourcePoolName}</a></Menu.Item>)}
                            </Menu>) : (<div style={{padding: '0 20px', backgroundColor: '#cfdbe6'}}>
                              前往<Button type='link' onClick={this.createPool} style={{padding: '4px 5px'}}>{t(`menu.resourcePool`)}</Button>创建
                            </div>)} placement="bottomLeft" disabled={!this.state.groupVal} >
                              <Button disabled={!this.state.groupVal} type="primary" onClick={e => e.preventDefault()} >{t(`marketingManagement.importResourcePool`)}</Button>
                            </Dropdown>
                          </div>
                        </Col>
                      </Row>
                  </Col>
                  {/* 重拨设置 */}
                  <Col span={12}>
                    <Form.Item name="enableRecalling" 
                    label={
                      <Tooltip title={t(`outboundCall.redialSettingTips`)}>
                        <span>{t(`outboundCall.redialSetting`)}<QuestionCircleFilled /></span>
                      </Tooltip>
                    } 
                    {...formItemLayout}>
                      <Switch 
                        checked={this.state.enableRecalling}
                        onChange={(checked) => {
                          this.setState({ enableRecalling: checked })
                          this.formRef.current.setFieldsValue({
                            'enableRecalling': checked,
                            'recallingNumber': 1,
                            'recallingInterval': 24,
                          })
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12} />
                  {/* 重拨设置详情 - 仅在重拨设置开启时显示 */}
                  {this.state.enableRecalling && (
                    <>
                      {/* <Col span={12}>
                        <Form.Item name="enableNoAnswer" label={t(`outboundCall.redialAfterNoAnswer`)} {...formItemLayout}>
                          <Switch 
                            defaultChecked={true}
                            onChange={(checked) => {
                              this.setState({ enableNoAnswer: checked })
                            }}
                          />
                        </Form.Item>
                      </Col> */}
                      <Col span={12}>
                        <Form.Item 
                          {...formItemLayout}
                          name="recallingNumber" 
                          label={t(`outboundCall.maxRedialTimes`)}
                          rules={[
                            { required: true, message: `${t(`general.pleaseEnter`)} ${t(`outboundCall.maxRedialTimes`)}` },
                            { type: 'number', min: 1, message: `${t(`general.pleaseEnterPositiveInteger`)}` }
                          ]}
                        >
                          <InputNumber min={1} defaultValue={1} style={{ width: '100%' }} />
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item 
                          {...formItemLayout} 
                          name="recallingInterval" 
                          label={
                            <Tooltip title={t(`outboundCall.redialIntervalHoursTips`)}>
                              <span>{t(`outboundCall.redialIntervalHours`)}<QuestionCircleFilled /></span>
                            </Tooltip>
                          }
                          rules={[
                            { required: true, message: `${t(`general.pleaseEnter`)} ${t(`outboundCall.redialIntervalHours`)}` },
                            { type: 'number', min: 24, message: `${t(`general.pleaseEnter`)} 大于等于24的正整数` }
                          ]}
                        >
                          <InputNumber min={24} defaultValue={24} style={{ width: '100%' }} />
                        </Form.Item>
                      </Col>
                    </>
                  )}
                  <Col span={24} style={{borderBottom: '1px solid #e8e8e8'}} />
                  
                  {/* 发送短信设置 */}
                  <Col span={12}>
                    <Form.Item name="smsEnabled" label={t(`outboundCall.sendSms`)} {...formItemLayout}>
                      <Switch 
                        checked={this.state.smsEnabled}
                        onChange={(checked) => {
                          this.setState({ smsEnabled: checked })
                          this.formRef.current.setFieldsValue({
                            'smsEnabled': checked,
                            'smsOn': ['1'],
                            'smsSignId': null,
                            'smsTemplateId': null,
                          })
                        }}
                      />
                    </Form.Item>
                  </Col>
                  
                  {/* 短信发送条件 - 仅在发送短信开启时显示 */}
                  {this.state.smsEnabled && (
                    <>
                      {/* { this.state.enableNoAnswer && <Col span={12}>
                        <Form.Item name="smsSendLimitType" label={
                            <Tooltip title={t(`outboundCall.allowDuplicateSendTips`)}>
                              <span>{t(`outboundCall.allowDuplicateSend`)}<QuestionCircleFilled /></span>
                            </Tooltip>
                        } {...formItemLayout}>
                          <Switch 
                            checked={this.state.smsSendLimitType} 
                            onChange={(checked) => {
                              this.setState({ smsSendLimitType: checked })
                            }}  
                          />
                        </Form.Item>
                      </Col>} */}
                      <Col span={12}>
                        <Form.Item name="smsOn" style={{paddingLeft: 145}}>
                          <Checkbox.Group>
                            <Checkbox value="1">{t(`outboundCall.sendAfterConnected`)}</Checkbox>
                            <Checkbox value="2">{t(`outboundCall.sendAfterNotConnected`)}</Checkbox>
                          </Checkbox.Group>
                        </Form.Item>
                      </Col>
                      
                      <Col span={12}>
                        <Form.Item name="smsSignId" label={t(`outboundCall.smsSignature`)} {...formItemProps}
                          disabled={!this.state.groupVal}
                          rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`outboundCall.smsSignature`)}`}]}
                        >
                          <Select placeholder={t(`general.pleaseSelect`)} allowClear showSearch filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                          } onChange={this.onChangeSign} disabled={!this.state.groupVal}>
                            {signList?.filter(a=>a?.marketingGroupId ===this.state.groupVal)?.map(item => (<Select.Option key={item.id} value={item.id}>{`【${item.sign}】`}</Select.Option>))}
                          </Select>
                        </Form.Item>
                      </Col>
                      
                      <Col span={12}>
                        <Form.Item name="smsTemplateId" label={t(`outboundCall.smsTemplate`)} {...formItemProps}
                          disabled={!this.state.groupVal}
                          rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`outboundCall.smsTemplate`)}`}]}
                        >
                          <Select placeholder={t(`general.pleaseSelect`)} allowClear showSearch filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                          } onChange={this.onChangeTemplate} disabled={!this.state.groupVal}>
                            {jobList?.filter(a=>a?.marketingGroupId ===this.state.groupVal)?.map(item => (<Select.Option key={item.id} value={item.id}>{item.templateName}</Select.Option>))}
                          </Select>
                        </Form.Item>
                      </Col>
                      
                      <Col span={24}>
                        <Form.Item name="smsPreview" label={t(`outboundCall.smsPreview`)} labelCol={{span: 4}} wrapperCol={{span: 20}} style={{marginBottom: 0}}>
                          <TextArea 
                            disabled 
                            rows={3} 
                            style={{ backgroundColor: '#f5f5f5' }}
                          />
                        </Form.Item>
                      </Col>
                      
                      <Col span={20} offset={4}>
                        <div className='interSum' style={{border: 0, textAlign: 'left'}}>
                          {t(`marketingManagement.total4`)}
                          <span style={{color: '#ff5200'}}>{this.state.strNum}</span>
                          {t(`marketingManagement.total2`)}
                          <span style={{color: 'red'}}>{this.state.smsNum}</span>
                          {t(`marketingManagement.total3`)}
                        </div>
                      </Col>
                    </>
                  )}
                </Row>
              </Form>
            </Col>
          </Row>
          </Spin>
        </Modal>
        {this.state.importModalVisible ? 
          <FormImport handleCancel={this.handleCancelImportFile} importModalVisible={this.state.importModalVisible} marketGroupId={this.state.groupVal} sourceType={this.state.sourceType} isTable={this.state.isTable} />
        : null}
        
        {this.state.detailsModalVisible ? 
          <ResourcePoolList handleCancel={this.handleCancelResourcePool} addModalVisible={this.state.detailsModalVisible} marketGroupId={this.state.groupVal} record={this.state.record} isSelect={true} type='4' />
        : null}
        {this.state.phoneVisible ? 
          <PhoneList handleCancel={this.handleCancelPhoneList} addModalVisible={this.state.phoneVisible} sourceType={this.state.sourceType} isValid={this.state.isValid} /> 
        : null}

        <Drawer
          title="测试发送"
          autoFocus={true}
          destroyOnClose={true}
          placement="top"
          closable={true}
          onClose={this.handleCancelTestSend}
          visible={this.state.testSendModalVisible}
          size='large'
          style={{ padding: '0px', overflow: 'auto' }}
          bodyStyle={{ overflowY: 'auto' }}
          maskClosable={false}
          extra={
            <Space>
              <Button type="primary" shape="round" loading={isTestSendFetching} onClick={this.handleTestSend}>{t('general.testSend')}</Button>
              <Button shape="round" onClick={this.handleCancelTestSend}>{t('general.close')}</Button>
            </Space>
          }
        >
          <Spin spinning={isTestSendFetching}>
            <Form ref={this.testFormRef} key="testForm">
              <Form.Item name="testPhoneArea" label="测试手机号" preserve={true}>
                <TextArea rows={5} allowClear={true} placeholder="请输入正确的手机号，多个手机号使用逗号分隔，测试手机号最多输入10个手机号"
                          style={{width: '95%'}}/>
              </Form.Item>
              <Form.Item name="testEmailAreaNotice" style={{marginBottom: 0}}>
                <div className="f_red" style={{marginLeft: '85px'}}><ExclamationCircleFilled/> 请输入正确的手机号，多个手机号使用逗号分隔，测试手机号最多输入10个手机号
                </div>
                <div className="f_red" style={{marginLeft: '85px'}}><ExclamationCircleFilled/> 测试时，只会发送短信，不会重拨。
                </div>
              </Form.Item>
            </Form>
          </Spin>
        </Drawer>
      </>
    )
  }
}

export default withTranslation()(FormModal)
